import { YStack } from '@/components/ui/layout/layout';

import { Callout } from './callout';

/**
 * What running on this device means for a bundled server. Shared by both
 * connect flows: the purpose-built bundled dialog, and the generic form that
 * requirement-carrying templates still fall back to.
 */
export function DeviceNoteCallout({ lines }: { lines: readonly string[] }) {
  return (
    <Callout tone="info">
      <YStack className="gap-1 text-xs leading-relaxed text-foreground-subtle">
        {lines.map((line) => (
          <span key={line}>{line}</span>
        ))}
      </YStack>
    </Callout>
  );
}
